import React, { useState } from "react";
import { colors } from "./colors";

const CardContainer = ({
  image,
  title,
  content,
  subject,
  cardClass,
  onClick,
}) => {
  const [imageSrc, setImageSrc] = useState(image || "/default_video.webp");

  return (
    <div
      style={{ boxShadow: "0px 0px 10px 0px #0000001A" }}
      className="flex flex-col items-center gap-1 rounded-[24px] hover:cursor-pointer w-[288px] border p-[8px]"
      onClick={onClick}
    >
      <div className="flex flex-col gap-4 rounded-[24px]">
        <img
          width={272}
          height={146}
          className="w-[272px] h-[146px] object-cover rounded-[24px]"
          src={imageSrc}
          alt={title}
          onError={() => setImageSrc("/default.png")} // Set fallback image on error
        />
        <div className="px-4 flex flex-col gap-4">
          {subject && (
            <div
              className="flex justify-between rounded-[20px] px-[8px] py-[4px]"
              style={{ boxShadow: "0px 0px 10px 0px #0000001A" }}
            >
              <span className="text-[16px] font-[500] text-[#212121]">
                {subject}
              </span>
              <span
                className="flex items-center justify-center text-[14px] font-[900] h-[24px] w-[24px] rounded-full"
                style={{ backgroundColor: colors[subject] || "#999999" }}
              />
            </div>
          )}
          {cardClass && (
            <div
              className="flex justify-between rounded-[20px] px-[8px] py-[4px]"
              style={{ boxShadow: "0px 0px 10px 0px #0000001A" }}
            >
              <span className="text-[16px] font-[500]">Դասարան՝</span>
              <span
                className="flex items-center justify-center text-[14px] font-[900] h-[24px] w-[24px] rounded-full"
                style={{ backgroundColor: colors[cardClass] || "#999999" }}
              >
                {cardClass}
              </span>
            </div>
          )}
        </div>
      </div>
      {content}
    </div>
  );
};

export default CardContainer;
